import { IEventItem } from '../../../../store/player/events/store';
import { EventHomeHeights } from './EventHomeHeights';
export const getRegistryHeight = (event: IEventItem) =>
  event.enrollment &&
  (event.enrollment.status === 'active' || event.enrollment.status === 'waiting')
    ? EventHomeHeights.EVENTSTATSREGISTERED
    : EventHomeHeights.EVENTSTATS;
